import { GET_HOME_CAROUSELS, GET_LAYOUT, GET_RECOMMEND, GET_STATIC_PATHS } from './type'
import moment from 'moment';

export function getPageLayout(pageName, d = null) {
    return (dispatch, getState, { axios }) => {
        return new Promise(resolve => {
            const date = d ? d : moment().format("YYYY-MM-DD HH:mm:ss")
            axios.post(`/api/web/layout`, {
                pageName,
                date
            })
                .then((response) => {
                    if (response.data.error) {
                        dispatch({
                            type: GET_LAYOUT,
                            page: pageName,
                            payload: []
                        })
                    } else {
                        dispatch({
                            type: GET_LAYOUT,
                            page: pageName,
                            payload: response.data.components
                        });
                    }
                    resolve(response.data);
                })
                .catch((error) => {
                    resolve(error);
                })
        });
    }
}

export function getPageLayoutStrapi(pageName, preview = false) {
    return (dispatch, getState, { axStrapi }) => {
        return new Promise(resolve => {
            // const date = d? d: moment().format("YYYY-MM-DD HH:mm:ss")
            dispatch({
                type: GET_LAYOUT,
                page: pageName,
                payload: []
            });
            axStrapi(preview ? `/page-layouts/${preview}?_publicationState=preview` : `/pages/${pageName}?source=web`)
                .then((response) => {
                    dispatch({
                        type: GET_LAYOUT,
                        page: pageName,
                        payload: preview ? response.data.content : response.data.page_layout.content
                    });
                    resolve(preview ? response.data.content : response.data.page_layout.content);
                })
                .catch((error) => {
                    dispatch({
                        type: GET_LAYOUT,
                        page: pageName,
                        payload: []
                    })
                    resolve(error)
                })
        });
    }
}

export function getRecommendSection(id) {
    return (dispatch, getState, { axStrapi }) => {
        return new Promise(resolve => {
            // const date = d? d: moment().format("YYYY-MM-DD HH:mm:ss")
            axStrapi.get(`/home-recommend-sections/${id}`)
                .then((response) => {
                    dispatch({
                        type: GET_RECOMMEND,
                        payload: response.data.content
                    });
                    resolve(response.data.content);
                })
                .catch((error) => {
                    dispatch({
                        type: GET_RECOMMEND,
                        payload: []
                    })
                    resolve(error)
                })
        });
    }
}

export function getHomeCarousels() {
    return (dispatch, getState, { axStrapi }) => {
        return new Promise(resolve => {
            axStrapi.get(`/home-carousel-banners`)
                .then((response) => {
                    dispatch({
                        type: GET_HOME_CAROUSELS,
                        payload: response.data
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    dispatch({
                        type: GET_HOME_CAROUSELS,
                        payload: []
                    })
                    resolve(error)
                })
        })
    }
}

export function getStaticPaths() {
    return (dispatch, getState, { axStrapi }) => {
        return new Promise(resolve => {
            axStrapi.get(`/pages`)
                .then((response) => {
                    dispatch({
                        type: GET_STATIC_PATHS,
                        payload: response.data,
                    })
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    dispatch({
                        type: GET_STATIC_PATHS,
                        payload: [],
                    })
                    resolve([]);
                })
        });
    }
}